module.exports = __webpack_public_path__ + "static/media/cbon.ebb31efc.png";